export default "__VITE_ASSET__DGvMh4TM__"